import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", testid }) => (
  <motion.div
    className={className}
    data-testid={testid}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "span" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          initial={{ y: "112%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.95, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 font-mono text-[11px] font-semibold uppercase tracking-[0.28em] ${
      dark ? "text-emerald-300/90" : "text-teal-700"
    }`}
  >
    <span className="h-px w-8 bg-current" />
    {children}
  </span>
);
